<template>
  <div class="gestione-trattativa">
    <div class="row row-custom">
      <div class="titolo-app col-lg-20 col-md-19 col-sm-17 col-1 no-padding">
        <span class="titolo-bold d-none d-sm-block">
          {{ $t('gestioneTrattativa.gestioneTrattativa').toUpperCase() }}
        </span>
      </div>
      <div class="icone col-lg-4 col-md-5 col-sm-7 col-23 no-padding row row-custom">
        <div class="col-24 icona" v-show="showNuovaTrattativa" @click="goToNuovaTrattativa">
          <div class="icona-menu">
            <icon name="riv-newTrattativa" scale="1.5"></icon>
          </div>
          <div class="label-menu no-padding">
            <span v-html="$t('gestioneTrattativa.nuovaTrattativa')"></span>
          </div>
        </div>
        <div class="col-24 icona" v-show="showListaTrattative" @click="goToLista">
          <div class="icona-menu">
            <icon name="riv-listTrattative" scale="1.5"></icon>
          </div>
          <div class="label-menu no-padding">
            <span v-html="$t('gestioneTrattativa.listaTrattative')"></span>
          </div>
        </div>
      </div>

      <div class="contenitore col-24 no-padding" :style="{ height: contenitoreHeight + 'px' }">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'GestioneTrattativa',
    props: {
      contenitoreHeight: {
        type: Number,
        required: true
      }
    },
    i18n: {
      messages: {
        it_IT: {
          gestioneTrattativa: {
            gestioneTrattativa: 'Gestione Trattativa',
            nuovaTrattativa: 'Nuova<br>Trattativa',
            listaTrattative: 'Lista<br>Trattative'
          }
        },
        fr_FR: {
          gestioneTrattativa: {
            gestioneTrattativa: ''
          }
        },
        es_ES: {
          gestioneTrattativa: {
            gestioneTrattativa: ''
          }
        },
        de_DE: {
          gestioneTrattativa: {
            gestioneTrattativa: 'Verwaltung Schrottverhandlungen',
            nuovaTrattativa: 'Neue<br>Verhandlung',
            listaTrattative: 'Verhandlung<br>Liste'
          }
        },
        en_GB: {
          gestioneTrattativa: {
            gestioneTrattativa: ''
          }
        }
      }
    },
    computed: {
      showNuovaTrattativa: function () {
        let path = this.$route.path
        return (path.indexOf('/rottame/gestionetrattativa/trattative') >= 0)
      },
      showListaTrattative: function () {
        let path = this.$route.path
        return (path.indexOf('/rottame/gestionetrattativa/trattativa') >= 0)
      }
    },
    data () {
      return {}
    },
    methods: {
      goToLista: function () {
        this.$router.push({ name: 'ElencoTrattative' })
      },
      goToNuovaTrattativa: function () {
        this.$store.commit('setIfNuovaTrattativa', true)
        this.$store.commit('setIfDuplicaTrattativa', false)
        this.$store.commit('setTrattativa', {})
        this.$router.push({ name: 'DettaglioTrattativa' })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .gestione-trattativa {
    .titolo-app {
      padding-left: 5px;
      // padding-bottom: 10px;
      // margin-top: 15px;
      font-size: 15px;
      color: #007c74;
      letter-spacing: 2px;
      overflow: hidden;
      height: 50px;
      line-height: 50px;
      .titolo-bold {
        font-weight: 700;
      }
    }
    .icone {
      padding-top: 10px;
      padding-bottom: 10px;
      .icona:hover {
        cursor: pointer;
      }
      .icona {
        text-align: right;
      }
      .icona-menu {
        padding-left: 0px;
        padding-right: 3px;
        // padding-top: 3px;
        text-align: right;
        display: inline-block;
        vertical-align: middle;
      }
      .label-menu {
        .set-font(@size: 13px; @family: 'os-semibold');
        text-align: center;
        display: inline-block;
        vertical-align: middle;
        line-height: 17px;
        // margin-top: -4px;
      }
    }
    .contenitore {
      -webkit-box-shadow: 0 0 10px 2px #cecece;
      -moz-box-shadow: 0 0 10px 2px #cecece;
      box-shadow: 0 0 10px 2px #cecece;
      background-color: #ffffff;
      margin: auto;
      overflow: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebGestioneTrattativa/GestioneTrattativa.vue